const AdviceTargetType = {
    OVER_ALL: {
        value: 1
    },
    BEGIN: {
        value: 2
    },
    JOUBUN: {
        value: 3
    },
    END: {
        value: 4
    }
}

export default AdviceTargetType;



// WEBPACK FOOTER //
// ./src/constants/legal_check/advice_target_type.js